/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-19 15:44:57
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-14 16:04:03
 * @FilePath: /src/components/Pay/AfterPay/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { getAfterpayUrl } from '@/api/pay';
import { useReporting } from '@/hooks/useReporting';
import { ProviderType } from '@/reporting';
import logger from '@/utils/client-logger';
import { forwardRef, useImperativeHandle } from 'react';

interface AfterPayProps {
  children?: React.ReactNode;
  onError: (msg?: string) => void;
}

const AfterPay = forwardRef<{ payAction: (order: any) => void }, AfterPayProps>(
  ({ children, onError }, ref) => {
    const { trackEvent } = useReporting();
    const payAction = async (_order: any) => {
      try {
        const { data: afterpayData } = await getAfterpayUrl({
          order_id: _order.order_id,
        });
        location.href = afterpayData.action.url;

        await trackInitiateCheckout();
      } catch (error) {
        logger.error('支付失败:', error);
        onError?.();
      }
    };

    useImperativeHandle(ref, () => ({
      payAction,
    }));

    // 封装跟踪支付事件的方法
    const trackInitiateCheckout = async () => {
      try {
        trackEvent(
          {
            eventName: 'InitiateCheckout',
          },
          [ProviderType.FACEBOOK],
        );
      } catch (error) {
        logger.error('跟踪支付事件失败:', error);
      }
    };

    return <>{children}</>;
  },
);

AfterPay.displayName = 'AfterPay';

export default AfterPay;
